import axios from 'axios'
import {Message} from 'element-ui';
import router from '../router'
import {mymessage} from '@/utils/mymessage';

/**
 * axios请求拦截器
 * @param {object} config axios请求配置对象
 * @return {object} 请求成功或失败时返回的配置对象或者promise error对象
 * **/
/*
axios.interceptors.request.use(config => {
  // 这里的config包含每次请求的内容
  console.log(config.url);
  if (config.url.indexOf("doLogin") === -1
    && config.url.indexOf("loadAllTopMenusOfCurrentUser") === -1) {
    if (sessionStorage) {
      //如果session为null就怎样
      // router.replace({path: '/'});
      if (!(sessionStorage.getItem("needSetPassword"))) {
        router.replace({path: '/'});
      } else if (sessionStorage.getItem("needSetPassword")) {
        router.replace({path: '/setPassword'});
      }
    } else {
      //如果session为null就怎样
      router.replace({path: '/'});
    }
  }

  config.withCredentials = true;
  return config;
})
*/
/**
 * axios 响应拦截器
 * @param {object} response 从服务端响应的数据对象或者error对象
 * @return {object} 响应成功或失败时返回的响应对象或者promise error对象
 **/
axios.interceptors.response.use(success => {
  if (success.status && success.status == 200 && success.data.status == 500) {
    Message.error({message: success.data.msg})
    return;
  }
  /*if (success.data.error) {
    Message.error({message: success.data.error})
  } else */
  if (success.data.msg) {
    Message.success({message: success.data.msg})
  }
  return success.data;
}, error => {
  if (error.response.status == 504 || error.response.status == 404) {
    Message.error({message: '服务器无响应'})
  } else if (error.response.status == 403) {
    Message.error({message: '权限不足，请联系管理员'})
  } else if (error.response.status == 401) {
    mymessage.error({message: error.response.data.msg ? error.response.data.msg : '尚未登录，请登录'})
    router.replace('/');
  } else {
    if (error.response.data.msg) {
      Message.error({message: error.response.data.msg})
    } else {
      Message.error({message: '未知错误!'})
    }
  }
  return;
})

let base = '';

export const postKeyValueRequest = (url, params) => {
  return axios({
    baseURL: process.env.BASE_API,
    method: 'post',
    url: `${base}${url}`,
    data: params,
    transformRequest: [function (data) {
      let ret = '';
      for (let i in data) {
        ret += encodeURIComponent(i) + '=' + encodeURIComponent(data[i]) + '&'
      }
      return ret;
    }],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    withCredentials: true
  });
}
export const postRequest = (url, params) => {
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    withCredentials: true
  })
}
export const putRequest = (url, params) => {
  return axios({
    method: 'put',
    url: `${base}${url}`,
    data: params,
    withCredentials: true
  })
}
export const getRequest = (url, params) => {
  return axios({
    method: 'get',
    url: `${base}${url}`,
    params: params,
    withCredentials: true
  })
}
export const deleteRequest = (url, params) => {
  return axios({
    method: 'delete',
    url: `${base}${url}`,
    params: params,
    withCredentials: true
  })
}



// WEBPACK FOOTER //
// ./src/utils/api.js